import React from 'react';

const CPATheme = {
  headerLogo: {
    src: '/themes/theme/crowdpointanalytics/cpa-horizontal.png',
    alt: 'CrowdPoint Analytics',
  },
  darkLogo: {
    src: '/themes/theme/crowdpointanalytics/cpa-vertical.png',
    alt: 'CrowdPoint Analytics',
    size: 100,
  },
  headerStyle: {
    backgroundColor: '#FFF',
    borderBottom: '2px solid #001F5B',
  },
  linkStyle: {
    color: '#000',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'CROWDPOINT ANALYTICS | CAMPAIGNS',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="200" src="/themes/theme/crowdpointanalytics/cpa-vertical.png" alt="CrowdPoint Analytics" />
      <br />
      <br />
      <p style={{ fontSize: 'large' }}>Automated Influencer Campaign Tracking</p>
      <hr />
    </div>
  ),
  shareSite: 'https://share.crowdpointanalytics.com',
};

export default CPATheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/crowdpointanalytics.js
 **/